// ─── Saved replies ───────────────────────────────────────────────────────────
//
// Wording a producer writes once and inserts into any message they compose —
// an email, a conversation, a guest broadcast, a request for a file. A reply is
// either the writer's own or shared with the office.
//
// Its body is plain text with `{{merge tags}}`. Plain rather than HTML because
// the same reply lands in a rich-text email and in a text message: the rich
// composer turns line breaks into paragraphs, the plain ones take it as it is.
/**
 * Every merge tag a saved reply may use, declared once.
 *
 * The server fills them from the record the message is about — an event, or
 * anything that hangs off one (an expense, a planning item, a guest…), or a
 * vendor — and from the person writing. The picker lists them from here, so a
 * tag cannot be offered that the server does not know how to fill.
 */
export const SAVED_REPLY_TOKENS = [
    { token: 'eventName', label: 'Event name', source: 'event', example: 'Cohen Wedding' },
    { token: 'eventDate', label: 'Event date', source: 'event', example: 'March 12, 2027' },
    { token: 'eventTime', label: 'Event time', source: 'event', example: '7:00 PM' },
    { token: 'venueName', label: 'Venue', source: 'event', example: 'The Addison' },
    {
        token: 'venueAddress',
        label: 'Venue address',
        source: 'event',
        example: '2 E Camino Real, Boca Raton, FL',
    },
    { token: 'clientName', label: 'Client name', source: 'event', example: 'Sarah Cohen' },
    { token: 'guestCount', label: 'Guest count', source: 'event', example: '180' },
    { token: 'vendorName', label: 'Vendor', source: 'vendor', example: 'Bella Catering' },
    {
        token: 'vendorContactName',
        label: 'Vendor contact',
        source: 'vendor',
        example: 'Maria Lopez',
    },
    { token: 'myName', label: 'My name', source: 'sender', example: 'Nechama' },
    { token: 'myEmail', label: 'My email', source: 'sender', example: 'office@np-productions.com' },
];
/** The placeholder a tag with no value is left as, for the writer to replace. */
export function unresolvedPlaceholder(token) {
    const known = SAVED_REPLY_TOKENS.find((t) => t.token === token);
    return `[${known?.label ?? token}]`;
}
//# sourceMappingURL=saved-reply.js.map